import React from 'react';
import GenericSelect from '../genericSelect/GenericSelect';
import Magnifier from './components/Magnifier';

const GenericSearchBar = ({
  searchString,
  setSearchString,
  customClassName,
  customPlaceholder,
  setIsSelectOpen,
  searchedOptions,
  handleChangeSelectedOption,
  initialValue,
  isSelectOpen,
  noResultsMessage,
  noResultsUpdater,
  isSearchDisabled
}: {
  searchString: string;
  setSearchString: React.Dispatch<React.SetStateAction<string>>;
  customClassName?: string;
  customPlaceholder?: string;
  setIsSelectOpen: React.Dispatch<React.SetStateAction<boolean>>;
  searchedOptions?: JSX.Element[];
  handleChangeSelectedOption?: React.Dispatch<any>;
  initialValue?: any;
  isSelectOpen?: boolean;
  noResultsMessage?: JSX.Element;
  noResultsUpdater?: React.Dispatch<React.SetStateAction<string>>;
  isSearchDisabled?: boolean;
}) => {
  const handleChange = (event: React.SyntheticEvent) => {
    const { value } = event.target as HTMLInputElement;
    setSearchString(value);
    if (!setIsSelectOpen) return;
    if (value?.length === 0) {
      setIsSelectOpen(false);
      noResultsUpdater && noResultsUpdater('');
      setSearchString('');
    }
    if (value?.length > 0) setIsSelectOpen(true);
  };
  
  const getSearchBarStyles = () => {
    const hasContent = searchString?.length > 0 || (customPlaceholder && customPlaceholder?.length > 0);

    if (isSearchDisabled) return 'disabled';

    if (!hasContent) return '';
    
    return initialValue === undefined ? 'inactive' : 'active';
  };

  const activeStyles = getSearchBarStyles();

  return (
    <>
      <div className={`generic-search-bar ${customClassName ? customClassName : ''} ${activeStyles}`}>
        <div className={`search-icon-container ${isSearchDisabled ? 'disabled' : ''}`}>
          <Magnifier />
        </div>
        <input
          value={searchString}
          className={`search-input ${isSearchDisabled ? 'disabled' : ''}`}
          placeholder={customPlaceholder || 'Buscar'}
          onChange={event => handleChange(event)}
          disabled={isSearchDisabled}
        />
        {(searchedOptions || noResultsMessage) && handleChangeSelectedOption && isSelectOpen && (
          <GenericSelect
            selectClassName="generic-search-select"
            selectOptions={searchedOptions ? searchedOptions : noResultsMessage ? [noResultsMessage] : []}
            changeSelectedOption={handleChangeSelectedOption}
            defaultValue={initialValue || undefined}
          />
        )}
      </div>
    </>
  );
};

export default GenericSearchBar;
